module.exports = "pegasus/assets/background-patterns/white-carbon-fiber.png";